var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopographicalLinesLime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e3141bef-8801-486f-a2ec-12cd8fc509a9",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1923.85 192.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M-.66,27.44s81.92-13.37,114.05,9.81,59,33.77,59,33.77,24.82,8.13,44.34,11,59.39,20.34,87,33.36,41.9,10.17,41.9,10.17,35-5.29,50.85-9.77a162.1,162.1,0,0,1,48-6.1c15.86.41,189.15.81,189.15.81a154.62,154.62,0,0,1,23.6,2.85c11.39,2.44,24.4,2.44,42.71-.4s144.4-26.85,144.4-26.85,53.29-6.1,106.17-5.7,102.1.41,135.46,1.63,41.08-11,41.08-11,45.56-43.53,146.45-47.39c0,0,54.1-4.68,109,4.27A925.19,925.19,0,0,0,1487.9,38.48S1688,53.12,1741.32,12c0,0,1.63-5.69,18.31-4.47s107,3.66,162.71,18.71",
    transform: "translate(0.99 -5.39)",
    style: {
      fill: "none",
      stroke: "#d9e026",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.66,153.75S39,147.09,64.17,134.47s96.41-6.1,96.41-6.1,42.71,4.48,124.47,23.19c0,0,38.24,6.91,63.87,5.69s85,11,85,11,121.22,28.88,181.83,27.66,135.46-1.63,135.46-1.63,7.73-12.61,56.14-18.71c0,0,11-1.63,19.93-3.66s64.68-5.7,157-4.48,159.45-10.57,159.45-10.57,67.12-7.73,139.53-1.63c0,0,33.76,3.25,59,8.14,0,0,32.14,6.9,57.36-2s63.86-17.49,63.86-17.49,25.22-6.91,33.36-11.39c0,0,10.57-6.91,58.17-2.44,0,0,124.06,14.24,190,14.24,0,0,91.53,4.47,117.15-4.88s50.24-13.71,57.87-13.57",
    transform: "translate(0.99 -5.39)",
    style: {
      fill: "none",
      stroke: "#d9e026",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopographicalLinesLime);
export default __webpack_public_path__ + "static/media/topographical-lines-lime.3a19c1071e870c1202f5e41da9d0e243.svg";
export { ForwardRef as ReactComponent };